/*
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */
import { Component } from "@angular/core";
import { PageCollectionService } from "./providers/page-collection";
var WizardStepnav = (function () {
    function WizardStepnav(pageService) {
        this.pageService = pageService;
    }
    return WizardStepnav;
}());
export { WizardStepnav };
WizardStepnav.decorators = [
    { type: Component, args: [{
                selector: "clr-wizard-stepnav",
                template: "\n        <ol class=\"clr-wizard-stepnav-list\" role=\"tablist\">\n            <li *ngFor=\"let page of pageService.pages\" clr-wizard-stepnav-item \n            [page]=\"page\" class=\"clr-wizard-stepnav-item\"></li>\n        </ol>\n    ",
                host: {
                    "class": "clr-wizard-stepnav"
                }
            },] },
];
/** @nocollapse */
WizardStepnav.ctorParameters = function () { return [
    { type: PageCollectionService, },
]; };
//# sourceMappingURL=wizard-stepnav.js.map


//////////////////
// WEBPACK FOOTER
// ./~/clarity-angular/wizard/wizard-stepnav.js
// module id = 223
// module chunks = 4